import React from 'react';
import { StageInfo } from '../../common/types';

export type StageGraphProps = {
  stages: StageInfo[];
};

export function StageGraph(props: StageGraphProps) {
  const { stages } = props;

  return (
    <div className="bg-[#192c46] rounded-lg shadow-md p-4">
      <div className="flex justify-between items-end flex-wrap overflow-hidden">
        {stages.map((stage, index) => (
          <div
            key={stage.stageUuid}
            className="flex flex-col items-center justify-end h-full w-24 max-w-24 sm:w-32 sm:max-w-32 mb-4"
          >
            {/* Stage name with flexible height */}
            <div className="text-center mb-2">
              <h3 className="text-white text-sm px-2">{stage.name}</h3>
            </div>

            {/* Stage node with number in center */}
            <div className="rounded-full bg-blue-500 flex items-center justify-center text-white font-bold w-12 h-12">
              <span className="text-lg">{stage.number}</span>
            </div>

            {/* Visual representation of puzzles */}
            <div className="flex space-x-1 mt-2">
              {stage.puzzles.map((puzzle) => (
                <div
                  key={puzzle.puzzleUuid}
                  className="w-3 h-3 bg-gray-600 rounded-full"
                  title={`Puzzle #${stage.number}.${puzzle.number}`}
                />
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
